import request from '@/utils/request'

//获取课程讨论区评论列表
export function commentList(data) {
	return request({
		url: '/api/comment/list',
		method: 'get',
		params: data
	})
} 

//发布评论
export function commentPublish(data) {
	return request({
		url: '/api/comment/publish',
		method: 'post',
		data
	})
}

//点赞
export function commentLike(data) {
	return request({
		url: '/api/comment/like?commentId='+data.commentId,
		method: 'post',
		data
	})
}
//取消点赞
export function commentCancelLikes(data) {
	return request({
		url: '/api/comment/cancelLikes?commentId='+data.commentId,
		method: 'post',
		data
	})
}

//我的评论
export function mycommentList(data) {
	return request({
		url: '/api/comment/my',
		method: 'get',
		params: data
	})
} 

//发布回复
export function replyPublish(data) {
	return request({
		url: '/api/reply/publish',
		method: 'post',
		data
	})
}
//更多回复
export function replyService(data) {
	return request({
		url: '/api/reply/replyService',
		method: 'get',
		params: data
	})
}